import { Component, input } from '@angular/core';

@Component({
  selector: 'app-svg-market-icon',
  templateUrl: './svg-market-icon.component.html',
  styleUrl: './style.css',
})
export class SvgMarketIconComponent {

  name = input.required<string>()

}
